import { defineComponent as n, useSlots as d, openBlock as i, createBlock as s, unref as a, mergeProps as f, createSlots as u, withCtx as o, renderSlot as l } from "vue";
import y from "./ghl-ui.es234.js";
const w = n({
  name: "UIPopover",
  inheritAttrs: !1
}), c = n({
  ...w,
  props: {
    trigger: {
      type: String,
      default: "hover"
    },
    delay: {
      type: Number
    },
    duration: {
      type: Number
    },
    placement: {
      type: String,
      default: "top"
    },
    show: {
      type: Boolean,
      default: void 0
    },
    showArrow: {
      type: Boolean,
      default: !0
    },
    positionX: {
      type: Number,
      default: void 0
    },
    positionY: {
      type: Number,
      default: void 0
    },
    onClickoutside: {
      type: Function,
      default: void 0
    },
    onUpdateShow: {
      type: Function,
      default: void 0
    },
    animated: {
      type: Boolean,
      default: !0
    },
    arrowPointToCenter: {
      type: Boolean,
      default: !1
    },
    arrowClass: {
      type: String,
      default: void 0
    },
    arrowStyle: {
      type: String || Object,
      default: void 0
    },
    arrowWrapperClass: {
      type: String,
      default: void 0
    },
    arrowWrapperStyle: {
      type: String || Object,
      default: void 0
    },
    contentClass: {
      type: String,
      default: void 0
    },
    contentStyle: {
      type: String || Object,
      default: void 0
    },
    footerClass: {
      type: String,
      default: void 0
    },
    footerStyle: {
      type: String || Object,
      default: void 0
    },
    headerClass: {
      type: String,
      default: void 0
    },
    headerStyle: {
      type: String || Object,
      default: void 0
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    flip: {
      type: Boolean,
      default: !0
    },
    keepAliveOnHover: {
      type: Boolean,
      default: !0
    },
    overlap: {
      type: Boolean,
      default: !1
    },
    raw: {
      type: Boolean,
      default: !1
    },
    scrollable: {
      type: Boolean,
      default: !1
    },
    title: {
      type: String,
      default: void 0
    },
    to: {
      type: [String, HTMLElement, Boolean],
      default: void 0
    },
    width: {
      type: [Number, String],
      default: void 0
    },
    zIndex: {
      type: Number,
      default: void 0
    }
  },
  setup(e) {
    const r = d();
    return (t, v) => (i(), s(a(y), f(t.$attrs, {
      "show-arrow": e.showArrow,
      show: e.show,
      placement: e.placement,
      trigger: e.trigger,
      delay: e.delay,
      duration: e.duration,
      x: e.positionX,
      y: e.positionY,
      "on-clickoutside": e.onClickoutside,
      animated: e.animated,
      "arrow-point-to-center": e.arrowPointToCenter,
      "arrow-class": e.arrowClass,
      "arrow-style": e.arrowStyle,
      "arrow-wrapper-class": e.arrowWrapperClass,
      "arrow-wrapper-style": e.arrowWrapperStyle,
      "content-class": e.contentClass,
      "content-style": e.contentStyle,
      disabled: e.disabled,
      flip: e.flip,
      "footer-class": e.footerClass,
      "footer-style": e.footerStyle,
      "header-class": e.headerClass,
      "header-style": e.headerStyle,
      "keep-alive-on-hover": e.keepAliveOnHover,
      overlap: e.overlap,
      raw: e.raw,
      scrollable: e.scrollable,
      title: e.title,
      to: e.to,
      width: e.width,
      "z-index": e.zIndex,
      "on-update:show": e.onUpdateShow
    }), u({
      default: o(() => [
        l(t.$slots, "default")
      ]),
      _: 2
    }, [
      a(r).trigger ? {
        name: "trigger",
        fn: o(() => [
          l(t.$slots, "trigger")
        ]),
        key: "0"
      } : void 0,
      a(r).header ? {
        name: "header",
        fn: o(() => [
          l(t.$slots, "header")
        ]),
        key: "1"
      } : void 0,
      a(r).footer ? {
        name: "footer",
        fn: o(() => [
          l(t.$slots, "footer")
        ]),
        key: "2"
      } : void 0
    ]), 1040, ["show-arrow", "show", "placement", "trigger", "delay", "duration", "x", "y", "on-clickoutside", "animated", "arrow-point-to-center", "arrow-class", "arrow-style", "arrow-wrapper-class", "arrow-wrapper-style", "content-class", "content-style", "disabled", "flip", "footer-class", "footer-style", "header-class", "header-style", "keep-alive-on-hover", "overlap", "raw", "scrollable", "title", "to", "width", "z-index", "on-update:show"]));
  }
}), S = c;
export {
  S as default
};
